// src/components/Footer.js
import React from "react";
import { Flex, VStack, Text, HStack, Link, useColorModeValue } from "@chakra-ui/react";
import { FaInstagram, FaFacebook } from "react-icons/fa";

const Footer = () => {
  const bg = useColorModeValue("#ECF0E5", "#1A202C");
  const textColor = useColorModeValue("gray.800", "white");

  return (
    <Flex
      as="footer"
      direction="column"
      width="100%"
      bg={bg}
      py={8}
      minH="unset"
      h="auto"
      flexShrink={0}
    >
      <Flex
        direction="column"
        align="center"
        maxW="6xl"
        mx="auto"
        px={4}
        width="100%"
      >
        {/* Fjernet værdata-boks, kun SoMe og copyright sentrert */}
        <VStack spacing={2} align="center">
          <HStack spacing={4} justify="center">
            <Link href="https://instagram.com" isExternal>
              <FaInstagram size={20} color={textColor} />
            </Link>
            <Link href="https://facebook.com" isExternal>
              <FaFacebook size={20} color={textColor} />
            </Link>
          </HStack>
          <Text fontSize="sm" color={textColor}>
            © {new Date().getFullYear()} Vangen Wood. All Rights Reserved.
          </Text>
        </VStack>
      </Flex>
    </Flex>
  );
}
export default Footer;